const HEADING = /^\d{1,2}\. /;

function Block({ line }) {
  if (HEADING.test(line)) {
    return <h2 className="font-serif text-xl sm:text-2xl text-ink leading-snug pt-8 first:pt-0">{line}</h2>;
  }
  if (line.startsWith("• ")) {
    return <p className="pl-5 text-[15px] font-light text-ink-soft/90 leading-relaxed">{line}</p>;
  }
  return <p className="text-[15px] font-light text-ink-soft/90 leading-relaxed">{line}</p>;
}

export default function LegalDoc({ title, text, testid }) {
  const lines = text.split("\n").filter((l) => l.trim() !== "");
  const [first, ...rest] = lines;
  return (
    <article data-testid={testid} className="bg-ivory pt-36 sm:pt-44 pb-24 sm:pb-32 px-6">
      <div className="max-w-3xl mx-auto">
        <p className="text-[11px] font-sans font-semibold uppercase tracking-[0.28em] text-burgundy/80">{title}</p>
        <h1 className="mt-6 font-serif text-3xl sm:text-4xl lg:text-5xl text-ink leading-[1.12] tracking-tight">{first}</h1>
        <div className="mt-10 sm:mt-12 space-y-4 border-t border-burgundy/10 pt-10">
          {rest.map((line, i) => (
            <Block key={i} line={line} />
          ))}
        </div>
      </div>
    </article>
  );
}
